var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "padding-nav" },
    [
      _c(
        "el-col",
        { attrs: { xs: 24, sm: 24, md: 13, lg: 13 } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "0.16rem" },
              attrs: { type: "text", icon: "el-icon-d-arrow-left" },
              on: { click: _vm.goback },
            },
            [_vm._v("Go back")]
          ),
          _vm._v(" "),
          _c("left-comp", {
            attrs: { tableMyList: _vm.tableMyList },
            on: {
              "update:tableMyList": function ($event) {
                _vm.tableMyList = $event
              },
              "update:table-my-list": function ($event) {
                _vm.tableMyList = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 24, sm: 24, md: 11, lg: 11 } }, [
        _c(
          "div",
          {
            staticClass: "spaceCenter flexStart",
            staticStyle: { "min-height": "6.4rem" },
          },
          [
            _c("place-bid", {
              attrs: { lastBid: _vm.lastBid },
              on: {
                "update:lastBid": function ($event) {
                  _vm.lastBid = $event
                },
                "update:last-bid": function ($event) {
                  _vm.lastBid = $event
                },
                refresh: _vm.refresh,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }